<template>
  <div
    v-if="
      scanTargetType === TYPE_SCHEDULE.webservices &&
      isRefreshing &&
      currentRefreshId === webserviceScanningId
    "
    class="custom-global-skeleton tw-w-full tw-h-[15px]"
  />
  <div
    v-else-if="
      scanTargetType === TYPE_SCHEDULE.domains &&
      isRefreshing &&
      currentRefreshId === domainScanningId
    "
    class="custom-global-skeleton tw-w-full tw-h-[15px]"
  />
  <div v-else :class="`tw-flex tw-gap-[15px] tw-h-[7px] ${className}`">
    <div
      v-for="(item, index) in hidden ? dataNumberDotsFiltered : dataNumberDots"
      :key="index"
    >
      <div class="tw-flex tw-items-center tw-justify-center tw-gap-[6px]">
        <span
          v-if="item.value || !hidden"
          :class="`tw-w-[7px] tw-h-[7px] tw-rounded-full tw-opacity-50`"
          :style="`background-color: ${item.color}`"
        />
        <span v-if="item.value || !hidden" class="text">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import store from "@/store";
import { computed, PropType } from "vue";
import { TYPE_SCHEDULE } from "@/utils/constants";

const props = defineProps({
  className: {
    type: String,
    required: false,
    default: "",
  },
  severity: {
    type: Object as PropType<
      Record<"critical" | "high" | "medium" | "low", number | string>
    >,
    required: false,
    default: () => ({
      critical: 0,
      high: 0,
      medium: 0,
      low: 0,
    }),
  },
  currentRefreshId: {
    type: [Number, String],
    required: false,
    default: 0,
  },
  scanTargetType: {
    type: String as PropType<keyof typeof TYPE_SCHEDULE>,
    required: false,
    default: "",
  },
  hidden: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const isRefreshing = computed(() => store.state.Scanning.isLoading);
const webserviceScanningId = computed<string>(
  () => store.state.Scanning.webserviceScanningId,
);
const domainScanningId = computed<string>(
  () => store.state.Scanning.domainScanningId,
);

const dataNumberDots = computed(() => {
  const colors = ["#F7553C", "#FE9A05", "#904BD6", "#57B755"];
  const data = [
    props.severity.critical || 0,
    props.severity.high || 0,
    props.severity.medium || 0,
    props.severity.low || 0,
  ];
  return colors.map((color, index) => ({
    color,
    value: data[index],
  }));
});
const dataNumberDotsFiltered = computed(() =>
  dataNumberDots.value.filter((item) => item.value),
);
</script>

<style lang="scss" scoped>
.text {
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  color: #231f20;
}
</style>
